var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseLightAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13c3.626 1.711 7.162 2.308 11.005 2.308 3.833 0 7.37-.597 10.995-2.308v1.857c-2.885 1.171-5.621 1.78-8.367 1.993v.912c0 .799-.395 1.238-1.097 1.238h-3.072c-.692 0-1.087-.44-1.087-1.238v-.912c-2.756-.214-5.492-.822-8.377-1.993z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.936 11.456c-.755 0-1.042.185-1.149.29-.103.102-.287.374-.287 1.109v10.24c0 .74.185 1.01.286 1.11.105.103.392.288 1.15.288h16.128c.765 0 1.05-.185 1.153-.287.099-.098.283-.367.283-1.112v-10.24c0-.737-.183-1.008-.285-1.108-.105-.104-.39-.29-1.151-.29zm12.1-1.5v-1.5a1.251 1.251 0 0 0-.128-.548.898.898 0 0 0-.183-.244c-.2-.187-.49-.285-.858-.285h-5.744c-.716 0-1.141.383-1.158 1.077l-.001.044v1.456zm1.238-2.67a1.945 1.945 0 0 0-.617-.8c-.438-.33-1.04-.492-1.79-.495h-5.744c-1.577.01-2.591.805-2.63 2.509-.002.035-.002.07-.002.105v1.351H7.936C5.98 9.956 5 10.916 5 12.855v10.24c0 1.948.979 2.898 2.936 2.898h16.128c1.967 0 2.936-.95 2.936-2.899v-10.24c0-1.938-.97-2.898-2.936-2.898h-2.555V8.5c-.011-.474-.09-.878-.235-1.214z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseLightAlt);
export default __webpack_public_path__ + "static/media/Briefcase-Light_ALT.1a74cdb57d07539a4d1290822998aa4d.svg";
export { ForwardRef as ReactComponent };